import { render, staticRenderFns } from "./OutrasInformacoesFormulaPerfil.vue?vue&type=template&id=48b04269"
import script from "./OutrasInformacoesFormulaPerfil.vue?vue&type=script&lang=js"
export * from "./OutrasInformacoesFormulaPerfil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports